import React from 'react';

import EpflLogo from './EpflLogo';

class EpflFooter extends React.Component{

    // method of EpflFooter class

  btnOnClik() {
    window.open("https://www.epfl.ch");
  }

  render () {
    return (
        <div className="bg-gray-100 pt-5 mt-auto">
            <div className="container">
                <footer className="footer-light" role="contentinfo">
                <div className="row">
                    <div className="col-6 mx-auto mx-md-0 mb-4 col-md-3 col-lg-2">
                    <a href="https://www.epfl.ch">
                        <EpflLogo />
                    </a>
                    </div>
                    <div className="col-md-9 col-lg-10 mb-4">
                    <div className="ml-md-2 ml-lg-5">
                        <ul className="list-inline list-unstyled">
                        <li className="list-inline-item">Contact</li>
                        <li className="list-inline-item text-muted pl-3"><small>EPFL CH-1015 Lausanne</small></li>
                        <li className="list-inline-item text-muted pl-3"><small>+41 21 693 11 11</small></li>
                        </ul>
                        <p className="footer-light-socials">
                        <small>Follow EPFL on social media</small>
                        <span>

                            <a href="true" className="social-icon social-icon-facebook social-icon-negative" rel="nofollow">
                                <svg className="icon" aria-hidden="true">
                                    <use xlinkHref="#icon-facebook"></use>
                                </svg>
                                <span className="sr-only">Follow us on Facebook.</span>
                            </a>
                            <a href="true" className="social-icon social-icon-twitter social-icon-negative" rel="nofollow">
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#icon-twitter"></use>
                            </svg>
                            <span className="sr-only">Follow us on Twitter.</span>
                            </a>
                            <a href="true" className="social-icon social-icon-instagram social-icon-negative" rel="nofollow">
                            <svg className="feather" aria-hidden="true">
                                <use xlinkHref="#icon-instagram"></use>
                            </svg>
                            <span className="sr-only">Follow us on Instagram.</span>
                            </a>
                            <a href="true" className="social-icon social-icon-youtube social-icon-negative" rel="nofollow">
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#icon-youtube"></use>
                            </svg>
                            <span className="sr-only">Follow us on Youtube.</span>
                            </a>
                            <a href="true" className="social-icon social-icon-linkedin social-icon-negative" rel="nofollow">
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#icon-linkedin"></use>
                            </svg>
                            <span className="sr-only">Follow us on LinkedIn.</span>
                            </a>
                        </span>
                        </p>

                        <div className="footer-legal">
                        <div className="footer-legal-links">
                            <a href="https://www.epfl.ch/about/overview/regulations-and-guidelines/disclaimer/">Accessibility</a>
                            <a href="https://www.epfl.ch/about/overview/regulations-and-guidelines/disclaimer/">Disclaimer</a>
                        </div>
                        <div>
                            <p>&copy; 2019 EPFL, all rights reserved</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </footer>

                <button id="back-to-top" className="btn btn-primary btn-back-to-top">
                <span className="sr-only">Back to top</span>
                <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-chevron-top"></use>
                </svg>
                </button>

            </div>
        </div>
    );
  }
}

export default EpflFooter;
